"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.highlightFirstAutomaticallyStateReducer = void 0;
var _downshift = require("downshift");
var _utils = require("../utils");
/**
 * StateReducer for SelectComboBox and MultiSelectComboBox for when highlightFirstOptionAutomatically is true.
 */
const highlightFirstAutomaticallyStateReducer = (options, currentState, actionsAndChanges) => {
  const {
    changes,
    type
  } = actionsAndChanges;
  switch (type) {
    case _downshift.useCombobox.stateChangeTypes.FunctionToggleMenu:
      if (!currentState.isOpen && changes.isOpen === true) {
        return {
          ...changes,
          highlightedIndex: (0, _utils.findNextValidOptionIndex)(options)
        };
      }
      break;
    case _downshift.useCombobox.stateChangeTypes.ToggleButtonClick:
      // if the menu is opening
      if (!currentState.isOpen && changes.isOpen === true) {
        return {
          ...changes,
          highlightedIndex: (0, _utils.findNextValidOptionIndex)(options)
        };
      }
      break;
  }
  return changes;
};
exports.highlightFirstAutomaticallyStateReducer = highlightFirstAutomaticallyStateReducer;
//# sourceMappingURL=highlightFirstAutomaticallyStateReducer.js.map